import { price, toCurrency, numberComma, floatComma, toCurrencyB } from "./currency";

import { defaultDate, defaultTime, defaultDateTime, isTimeExceeded } from "./date";

import { colorRocket, namePlatForm, checkRocket, classTablePlatform, classBodyTable,nameTheme,classTable } from "./color-theme";

import { formatBankAccount, formatTel, formatCardId} from "./string";
/**
 * You can register global filters here and use them as a plugin in your main Vue instance
 */
export default {
  toCurrency,
  price,
  numberComma,
  defaultDate,
  defaultTime,
  defaultDateTime,
  isTimeExceeded,
  colorRocket,
  namePlatForm,
  classTablePlatform,
  classBodyTable,
  checkRocket,
  nameTheme,
  classTable,
  floatComma,
  toCurrencyB,
  formatBankAccount,
  formatTel,
  formatCardId,
};

// const GlobalFilters = {
//   install (Vue) {
//     Vue.filter('price', price)
//     Vue.filter('toCurrency', toCurrency)
//     Vue.filter('defaultDate', defaultDate)
//     Vue.filter('defaultTime', defaultTime)
//     Vue.filter('defaultDateTime', defaultDateTime)
//   }
// }

// export default GlobalFilters
